module.exports = __webpack_public_path__ + "static/media/4.11df9df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Hero/4.jpg
// module id = 253
// module chunks = 0